// File: src/components/sections/HeroSection/HeroSection.tsx
import React from "react";
import { DefaultSection, DefaultSectionProps } from "./DefaultSection";
import { Button } from "../../general/Button";
import { Typography } from "../../general/Typography";
import { Flex } from "../wrappers";

interface HeroSectionProps extends DefaultSectionProps {
  title?: string | null | false;
  subtitle?: string | null | false;
  description?: string | null | false;  
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  title ,
  subtitle ,
  description ,
  backgroundMedia,
  onPrimaryAction,
  onSecondaryAction,
  actions,
  contentOverlay,
  ...props
}) => {
  return (
    <DefaultSection
      sectionId="hero"
      title={title}
      subtitle={subtitle}
      content={description}
      backgroundMedia={backgroundMedia && {
        type: "video",
        useMediaLoader: true,
        mediaName: backgroundMedia?.mediaName || "eli-001",
        mediaBaseUrl: backgroundMedia?.mediaBaseUrl || "https://cdn.ushi.care",
      }}
      contentOverlay={
        contentOverlay === null || contentOverlay === false
          ? undefined
          : contentOverlay || {
              color: "rgba(255,255,255,0.25)",
              blur: false,
              borderRadius: "0.5rem",
              padding: "1rem",
            }
      }
      fullHeight
      snap
      animateOnScroll
      parallax
      actions={
        actions === undefined ? (
          <Flex gap="md" wrap="wrap" justify="center">
            <Button variant="primary" size="large" onClick={onPrimaryAction}>
              Get Started
            </Button>
            <Button variant="secondary" size="large" onClick={onSecondaryAction}>
              Explore
            </Button>
          </Flex>
        ) : actions || undefined
      }
      {...props}
    />
  );
};
